export default function getFormat(datetime: boolean, monthOnly?: boolean) {
  if (monthOnly) {
    return 'MMM YYYY';
  }

  if (datetime) {
    return 'DD/MM/YYYY kk:mm A';
  }

  return 'DD/MM/YYYY';
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/datepicker/config.ts